import type { IOrganizationLeftNotificationData } from "@frontend-shared/types";
import { LogOut } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IOrganizationLeftCardProps {
  uuid: string;
  data: IOrganizationLeftNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewOrganization: (organizationUuid: string) => void;
}

const OrganizationLeftCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewOrganization,
}: IOrganizationLeftCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewOrganization = useCallback(
    () => onViewOrganization(data.organizationUuid),
    [onViewOrganization, data.organizationUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="organization_left"
      createdAt={createdAt}
      isRead={isRead}
      icon={<LogOut className="h-5 w-5" />}
      ctaLabel={t("view_organization")}
      onCtaClick={handleViewOrganization}
      body={t("type.organization_left.body", {
        organizationName: data.organizationName,
        memberName: data.memberName,
      })}
    />
  );
};

export const OrganizationLeftCard = memo(OrganizationLeftCardComponent);
